import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { connect } from 'react-redux';
import { api, contentPageUploadDir } from '../../config';
import { getDynamicTitleByLocale } from '../../helpers/getDynamicTitle';
import s from './ContentPage.css';
class ContentPage extends React.Component {
    static propTypes = {
        title: PropTypes.string.isRequired
    }

    render() {
        const { title, data, currentLocale } = this.props;
        let addClass = 'ql-editor frontend', dynamicContentSettings, content;

        dynamicContentSettings = getDynamicTitleByLocale({ dynamicHomePageSettings: data?.dynamicContentDetails, locale: currentLocale });

        content = dynamicContentSettings[0]?.content || data?.content;

        return (
            <div>
                {
                    data?.pageBanner && <div
                        className={s.backGroungImg}
                        style={{ backgroundImage: `url(${api.apiEndpoint + contentPageUploadDir + data?.pageBanner})` }} />
                }
                <div className={s.cotainer}>
                    <div className={cx(s.staticContainer, 'textAlignRightRTL')}>
                        <h1>{title}</h1>
                        <div className={addClass} dangerouslySetInnerHTML={{ __html: content || '' }} />
                    </div>
                </div>
            </div>
        )
    }
}

const mapState = (state) => ({
    currentLocale: state?.intl?.locale
});

const mapDispatch = {
};

export default withStyles(s)(connect(mapState, mapDispatch)(ContentPage));